import * as React from 'react';
import { SiteHeaderLayout } from '../entities/site-header-layout';
export var SiteHeaderComponentContext = React.createContext(SiteHeaderLayout);
export var SiteHeaderComponentProvider = SiteHeaderComponentContext.Provider;